


















import { Vue, Component, Watch } from 'vue-property-decorator';
import LifecycleModule from '@/store/modules/lifecycle';
import UserModule from '@/store/modules/user';
import UIModule from '@/store/modules/ui';
import FlagUtil from '@/util/FlagUtil';
import { PartnersApi, Partner } from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import PartnerModule from '@/store/modules/partner';

@Component({
  components: {},
})
export default class Sidebar extends Vue {
  public async mounted() {
    await this.getPartnerInfo();
  }

  @Watch('$route')
  async onRouteChange() {
    this.getPartnerInfo();
  }

  public partnerInfo:Partner = {};

  public async getPartnerInfo() {
    const partnerId = this.$route.params.id;
    const { data } = await new PartnersApi(AppModule.apiConfig).getPartnerById(partnerId);
    this.partnerInfo = data;
    PartnerModule.SET_ACTIVE_PARTNER(data);
  }

  private sideNavigation = [
    {
      title: 'Basic Information',
      route: {
        name: 'partner-detail',
      },
    },
    {
      title: 'Forms',
      route: {
        name: 'document-list',
      },
    },
    {
      flag: 'partner.scheduleSettings',
      title: 'Schedule Settings',
      route: {
        name: 'schedule-settings-partners',
      },
      prop: 'enabledScheduling',
    },
  ];

  get enabledScheduling() {
    const { marketId } = PartnerModule.activePartner;

    if (FlagUtil.getFlags().market.scheduler_disabled.includes(marketId)) {
      return false;
    }

    const enabled = FlagUtil.getFlags().market.scheduler_enabled;
    if (enabled && enabled.includes(marketId)) {
      return true;
    }
    // check market here
    return false;
  }

  hasFlag(flag? : string) {
    if (!flag) return true;
    return FlagUtil.hasFeature(flag);
  }

  checkProp(prop?: string) {
    if (!prop) return true;
    return this[prop];
  }
}
